
import Transformer from './../../transformer'

export default class ConceptsCatalogTransfomer extends Transformer {
  static fetch({ id, name, slug, customer, current_catalog: isCurrent  }) {
    return {
      id,
      name,
      slug,
      customer,
      isCurrent
    }
  }
}



// WEBPACK FOOTER //
// ./src/transformers/catalog/services/ConceptsCatalog.js